function NewInDepthTestLinks() {
    return {
        surveyDate: null,       
        programsDate: null,
		surveyType: null,
		usersToCreate: null,		
		demoSets: []		
      }
}
export default NewInDepthTestLinks;